import axiosInstance from "@/axios/axiosInstance";
import { LoginCredentials } from "@/interface/auth.types";
import {
  Address,
  ApiResponse,
  PasswordChange,
} from "@/interface/profile.types";
import { PersonalDetailsFormData } from "@/interface/types";

export interface RegisterPayload {
  userName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export const registerUser = async (payload: RegisterPayload) => {
  const response = await axiosInstance.post(
    "/Identity/Register",
    payload
  );

  return response.data;
};

export const loginUser = async (data: LoginCredentials) => {
  try {
    const payload = {
      username: data.username,
      password: data.password,
    };
    const response = await axiosInstance.post(`/Identity/login`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const updatePersonalDetails = async (
  data: PersonalDetailsFormData
): Promise<ApiResponse<PersonalDetailsFormData>> => {
  try {
    const response = await axiosInstance.put<
      ApiResponse<PersonalDetailsFormData>
    >("/profile", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (
  data: PasswordChange
): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance.put<ApiResponse<null>>(
      "/Identity/ChangePassword",
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
